import VisibleComponent from "../VisibleComponent";
import Button from "../Button";

const template = `
    <div class="mtg-mute-switchable-button"></div>
`

class MuteSwitchableButton extends VisibleComponent {
    constructor(options) {
        super(options);
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options);

        this.mutedBtn = new Button({
            type: 'muted',
            theme: 'black',
            onClick: e => {
                this.mutedBtn.removeSelf()
                this.unmutedBtn.appendTo(this.element)
                options && typeof options.onClick === 'function' && options.onClick(e)
            }
        })

        this.unmutedBtn = new Button({
            type: 'unmuted',
            theme: 'black',
            onClick: e => {
                this.unmutedBtn.removeSelf()
                this.mutedBtn.appendTo(this.element)
                options && typeof options.onClick === 'function' && options.onClick(e)
            }
        })

        if (options && options.muted) {
            this.mutedBtn.appendTo(this.element)
        } else {
            this.unmutedBtn.appendTo(this.element)
        }
    }

    changeMountedBtn(muted) {
        if (muted) {
            this.unmutedBtn.removeSelf()
            this.mutedBtn.appendTo(this.element)
        } else {
            this.mutedBtn.removeSelf()
            this.unmutedBtn.appendTo(this.element)
        }
    }
}

export default MuteSwitchableButton